
import React, { useEffect, useRef, useState,useMemo } from 'react';
import { IsPhone,IsEmail,isOnlyNo  } from '@/utils/utils';
import { encrypt, decrypt  } from '@/utils/crypto';
import ReactPlayer from 'react-player'
import $ from 'jquery'

import { dataStatistics  } from '@/utils/monitor';

import './index.less';

let timer = ''
const VideoPage = (props) => {
  
  const { history } = props;
  const [playvideostate, setPlayvideo] = useState(false);
  const [usersubstate, setUsersubstate] = useState(false);
  const [layerstate, setLayerstate] = useState(false);

  const [timeadd, setTimeadd] = useState("");

  const [qastate, setQastate] = useState(false);
  const [bigstate, setBigstate] = useState(false);

  

  const [userinfostate,setUserinfostate] = useState(0)
  const [sublist,setSublist] = useState({
    content:'',
    enroll_id:'',
    activity_id:'',
    source:1,
  })
  const [sublisterror,setSublisterror] = useState({
    content:false,
  })

  const [sourcelist,setSourcelsit] = useState([2,4,5,6,7,8])
  const [enroll_id,setSenroll_id] = useState("")

  

  useEffect(() => {
    return () => {
      console.log(timer)
      clearTimeout(timer)
    }
  }, []);
  useEffect(() => {
      console.log(3333)
      dataStatistics()
      let is_login =  localStorage.getItem("is_login");
      let senroll_id =  localStorage.getItem("enroll_id");
      if(is_login!=1 || !senroll_id){
        history.push('/')
      }else{
        setSenroll_id(senroll_id)
      }
    
    },[])

  const getUrlkey = (url) =>{
    var params = {};
    var urls = url.split("?");                  //////console.log('1_分割url:', urls)
    var arr = urls[1].split("&");               //////console.log('2_分割urls[1]:', arr)
    for (var i = 0, l = arr.length; i < l; i++) {
      var a = arr[i].split("=");                //////console.log('3_遍历 arr 并分割后赋值给a:', a[0], a[1])
      params[a[0]] = a[1];                      //////console.log('4_a给params对象赋值:', params)
    }                                           //////console.log('5_结果:', params)
    return params;
  }
  const addplaytime =()=>{
    timer =  setTimeout(function(){
      let ids=92;
      if(window.location.href.indexOf('?')>=0){
        let urls =  getUrlkey(window.location.href)
        ids=urls.id
      }
      let subuserlisttemp = {}
      subuserlisttemp['enroll_id'] = enroll_id;
      subuserlisttemp['activity_id'] = ids;
      subuserlisttemp['time'] = 5;
      subuserlisttemp['source'] = 1; 

      React.$request({
        method: "post",
        url: '/api/platform/activity/live/time',
        data: subuserlisttemp,
      }).then(res => {
        
      }).catch(() => {
        
      });
      addplaytime()
    },5000)
  }
  let playvideo = ()=>{
    let video =  $('video')[0];
    video.play()
    setPlayvideo(true)
    addplaytime();
  }
  const valueChange = (e) =>{
    sublist[e.target.name] = e.target.value
    setUsersubstate(!usersubstate)
    setSublist(sublist);


    sublisterror[e.target.name] = false
    setSublisterror({...sublisterror})
    console.log(sublist)
  }
  const subuserlist = ()=>{
    let subuserlisttemp ={};

    if(!sublist['content']){
      
      if(!sublist['content']){
        sublisterror['content']=true
      }
      setSublisterror({...sublisterror})
      return false;
    }
    let ids=92;
    if(window.location.href.indexOf('?')>=0){
      let urls =  getUrlkey(window.location.href)
      ids=urls.id
    }
    subuserlisttemp['enroll_id'] = enroll_id;
    subuserlisttemp['content'] = (sublist['content']);
    subuserlisttemp['activity_id'] = ids;
    subuserlisttemp['source'] = 1; 

    React.$request({
      method: "post",
      url: '/api/platform/activity/questions',
      data: subuserlisttemp,
    }).then(res => {
      console.log(res)
      if(res.data.code==1000){
        setLayerstate(true)
        setSublist({
          content:'',
          enroll_id:enroll_id,
          activity_id:'',
          source:1,
          
        })
      }
    }).catch(() => {
      
    });
  }
  const qalayer = ()=>(
    <div className="qalayer">
      <div className="qalaery_close" onClick={()=>setLayerstate(false)}></div>
      <div className="qalayer_icon"></div>
      <div className="qalayer_tips">您的疑问我们已收到，<br></br>我们会现场为您解答或稍后邮件回复您的疑问！</div>
    </div>
  )
  const biglayer = ()=>(
    <div className="biglayer">

      <div className="codeclose cursor"  onClick={()=>setBigstate(false)} ></div>
      <div className="biglayerbox">
        <div className="biglayertext">本次活动的直播回放将在GLG官方微信号内发布，<br></br>您可以扫描下方二维码获取发布地址。</div>
        <div className="codeimg"><img src={require("../../static/videocode.jpg")} /></div>
      </div>
    </div>
  )
  return <div className="video_page">
    {bigstate?biglayer():null}
    <div className="video_top">
      <div className="video_logo"></div>
    </div>
    <div className="video_box">
      <div className="video_right">
        <div className="video_right_title">GLG格理集团</div>
        <div className="video_right_topic">汇聚专业洞见，助力卓越决策</div>
        <div className="video_right_desc">GLG致力于打造全球知识平台，为需要专业洞见的商业决策者匹配具有一手经验的行业专家，助力他们以更加明确的目标和坚定的信心做出决策。<br></br>我们的全球专家团规模首屈一指，汇聚多样化的第一手专业知识，此外，我们每天招募数百名新的专家成为专家团成员。以全球约100万名行业专家和2.500名员工的专业服务为依托，GLG在严格的合规框架基础上为客户提供全天候的定制化服务。</div>
        <div className="video_right_btnbox">
          <span onClick={()=>setBigstate(true)}>了解更多</span>
        </div>

        
      </div>
      <div className="video_left">
        <div className="video_info">
          <div className="video">
          <ReactPlayer 
              height="100%"
              width="100%"
              controls
              url="https://videoclip.quanshi.com/res/prod/014126/8029302/editor/2022/08/18/video-compiled/862089da-ce29-450e-a592-af5e9a4629ef/862089da-ce29-450e-a592-af5e9a4629ef.mp4"

          />
          </div>
        {!playvideostate? <div className="video_play" onClick={playvideo}></div>:null}
        </div>

        <div className="video_bottom">
          <div className={qastate?"video_qabox":"none"}>
            {layerstate?qalayer():null}
            <div className="video_close"  onClick={()=>setQastate(false)}></div>
            <div className="video_qatitle">请输入您的问题，我们有机会为您现场解答！</div>

            {/* <div className="vdieo_inputbox">
              <div className="video_lefttitle name">姓名<span></span></div>
              <div className="video_rightbox"><input type='text' value={sublist['name']}  name="name"  onChange={valueChange} /></div>
              {sublisterror['name']?<div className="video_error">请输入姓名</div>:null}
            </div>

            <div className="vdieo_inputbox">
              <div className="video_lefttitle company">公司<span></span></div>
              <div className="video_rightbox"><input type='text'  value={sublist['company']}   name="company"   onChange={valueChange} /></div>
              {sublisterror['company']?<div className="video_error">请输入公司</div>:null}
            </div>

            <div className="vdieo_inputbox">
              <div className="video_lefttitle email">邮箱<span></span></div>
              <div className="video_rightbox"><input type='text'  value={sublist['email']}   name="email"   onChange={valueChange} /></div>
              {sublisterror['email']?<div className="video_error">请输入正确邮箱</div>:null}
            </div> */}

            <div className="vdieo_inputbox ismore">
              <div className="video_lefttitle asker">疑问<span></span></div>
              <div className="video_rightbox"><textarea    name="content" value={sublist['content']}  onChange={valueChange}>{sublist['content']}</textarea></div>
              {sublisterror['content']?<div className="video_error">请输入疑问</div>:null}
            </div>
            <div className="video_btn" onClick={subuserlist}>提交</div>
          </div>
          <div className="video_title">“碳中和”下的风电光伏产业及储能配套发展</div>
          <div className="video_time">2022年8月17日  下午3:00 - 4:30</div>
          <div className="video_talkbtn" onClick={()=>setQastate(true)}>
            实时提问
          </div>
          {/* <div className="video_regs" onClick={()=>setBigstate(true)}>
            订阅回放
          </div> */}
        </div>
      </div>
    </div>
    <div className="video_bottombox">
    如您对于观看网络直播有困难，<br></br>
    请发电子邮件给apac_events@glgroup.com或于实时提问处留言寻求帮助
    </div>
  </div>
}

export default VideoPage;
